<template>
	<div>
		<app-table
			class="mt-2 is-not-selectable"
			:columns="columns"
			:current-page="currentPage"
			:items-quantity="itemsQuantity"
			:items-total-quantity="itemsTotalQuantity"
			:last-page="lastPage"
			:filter-columns="false"
			:number-seats="numberSeats"
			name="ledger"
			padding="px-0"
			:rows="rows"
			@on-page="$emit('on-page', $event)"
			@on-search-event="$emit('on-search', $event)"
			@row-on-click="$emit('row-on-click', $event)"
		>
			<template slot="rows" slot-scope="props">
				<td	class="is-not-selectable"
					v-show="showRow(columns, 1)">
					<input
						:id="`row-${props.row.id}-${props.index}`"
						hidden
						@keyup.up="$emit('up-selected', props.row)"
						@keyup.down="$emit('down-selected', props.row)"
					/>
					{{ props.row.accountingSeat.date || null | exactDate }}
				</td>
				<td v-show="showRow(columns, 2)">{{ props.row.accountingSeat.code  || null}}</td>
				<td v-show="showRow(columns, 3)">{{ props.row.reference || null }}</td>
				<td v-show="showRow(columns, 4)">{{ props.row.concept || null }}</td>
				<td class="text-xs-right pr-1" v-show="showRow(columns, 5)">
					<span v-if="hasAmount(props.row.amountDebe)">{{ props.row.amountDebe | formatAmount }}</span>
					<span v-else class="amount-empty">-</span>
				</td>
				<td class="text-xs-right pr-1" v-show="showRow(columns, 6)">
					<span v-if="hasAmount(props.row.amountHaber)">{{ props.row.amountHaber | formatAmount }}</span>
					<span v-else class="amount-empty">-</span>
				</td>
				<td v-show="showRow(columns, 7)">{{ props.row.accountingAccount ? props.row.accountingAccount.name : null }}</td>
				<td class="text-xs-center" v-show="showRow(columns, 8)">
					<button
						v-if="getRegister(props.row)"
						type="button"
						class="btn-doc"
						:title="`Ver detalle de ${getRegister(props.row).documentNumber || 'documento'}`"
						@click.stop="openDetailDocument(props.row)"
					>
						<v-icon size="15">description</v-icon>
					</button>
					<span v-else class="btn-doc btn-doc--empty">&mdash;</span>
				</td>
			</template>
		</app-table>

		<!-- ============ DETALLE DEL DOCUMENTO RELACIONADO ============ -->
		<v-dialog
			v-model="showDetails"
			persistent
			width="620"
			content-class="doc-dialog">
			<v-card v-if="showDetails" class="doc-card">
				<div class="doc-card__head">
					<div class="doc-card__head-left">
						<v-icon color="white" size="20">description</v-icon>
						<span class="doc-card__title">Documento relacionado</span>
					</div>
					<button type="button" class="doc-card__close" @click="closeDetailDocument">
						<v-icon color="white" size="18">close</v-icon>
					</button>
				</div>

				<div class="doc-hero">
					<div class="doc-hero__doc">
						<span class="doc-label">N&deg; Documento</span>
						<span class="doc-hero__number">{{ detailsRegister.documentNumber || '—' }}</span>
						<div class="doc-hero__chips">
							<span v-if="detailsRegister.moduleCode" class="doc-chip doc-chip--module">
								{{ detailsRegister.moduleCode }}
							</span>
							<span v-if="registerDate" class="doc-chip">{{ registerDate | exactDate }}</span>
						</div>
					</div>
					<div class="doc-hero__amount">
						<span class="doc-label">Monto</span>
						<span class="doc-hero__value">$ {{ registerData.amount || 0 | formatAmount }}</span>
					</div>
				</div>

				<div class="doc-grid">
					<div
						v-for="(item, index) in detailRows"
						:key="index"
						class="doc-item"
						:class="{ 'doc-item--wide': item.wide }"
					>
						<span class="doc-label">{{ item.label }}</span>
						<span
							class="doc-item__value"
							:class="{ 'doc-item__value--free': item.wide }"
							:title="item.value"
						>
							{{ item.value }}
						</span>
					</div>
				</div>

				<div class="doc-card__foot">
					<button type="button" class="doc-btn" @click="closeDetailDocument">Cerrar</button>
				</div>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import appTooltipButton from '@/components/shared/app-tooltip-button';

const MODULES_WITHOUT_ENTITY = ['BANCO', 'CAJA'];
const MODULES_WITH_AMORTIZATION = ['CTAXPAG', 'CTAXCOB'];

function data() {
	return {
		detailsRegister: null,
		showDetails: false,
		columns: [
			{
				id: 1,
				name: 'Fecha',
				value: 'date',
				checked: true,
				visible: true,
				movil: true,
			},
			{
				id: 2,
				name: 'Asiento',
				value: 'seatCode',
				checked: true,
				visible: true,
				movil: true,
			},
			{
				id: 3,
				name: 'Referencia',
				value: 'reference',
				checked: true,
				visible: true,
				movil: true,
			},
			{
				id: 4,
				name: 'Concepto',
				value: 'concept',
				checked: true,
				visible: true,
				movil: true,
			},
			{
				id: 5,
				name: 'Debe',
				value: 'totalDebt',
				checked: true,
				visible: true,
				movil: true,
			},
			{
				id: 6,
				name: 'Haber',
				value: 'totalHaber',
				checked: true,
				visible: true,
				movil: true,
			},
			{
				id: 7,
				name: 'Origen',
				value: 'origin',
				checked: true,
				visible: true,
				movil: true,
			},
			{
				id: 8,
				name: 'Documento Relacionado',
				value: 'relatedDocument',
				checked: true,
				visible: true,
				movil: true,
			},
		],
		iconWidth: 12,
	};
}
function hasAmount(value) {
	const amount = Number(value);
	return Number.isFinite(amount) && amount !== 0;
}
// register puede venir null: en ese caso la celda no muestra boton
function getRegister(row) {
	const seat = row && row.accountingSeat ? row.accountingSeat : null;
	return seat && seat.register ? seat.register : null;
}

function openDetailDocument(row) {
	const register = this.getRegister(row);
	if (!register) {
		return;
	}
	this.detailsRegister = register;
	this.showDetails = true;
}

function closeDetailDocument() {
	this.showDetails = false;
	this.detailsRegister = null;
}

function registerData() {
	return this.detailsRegister && this.detailsRegister.data ? this.detailsRegister.data : {};
}

function registerExtra() {
	const info = this.registerData;
	return info.additionalInformation || {};
}

function registerDate() {
	const info = this.registerData;
	const fallback = this.detailsRegister ? this.detailsRegister.dateRegister : null;
	return info.dateEmission || info.paymentDate || fallback || null;
}

function typePaymentName() {
	const info = this.registerData;
	if (info.typePayment && info.typePayment.name) {
		return info.typePayment.name;
	}
	const transactions = info.transactions || [];
	if (transactions.length > 0 && transactions[0].typePayment) {
		return transactions[0].typePayment.name || '';
	}
	return '';
}

// Se arma la lista y se descartan los vacios, para que la grilla no deje huecos
function detailRows() {
	if (!this.detailsRegister) {
		return [];
	}
	const info = this.registerData;
	const extra = this.registerExtra;
	const code = this.detailsRegister.moduleCode;
	const entity = this.getLabelRegister();
	const items = [];
	if (MODULES_WITHOUT_ENTITY.indexOf(code) < 0 && entity.label) {
		items.push({ label: entity.label, value: entity.value || '—' });
	}
	if (this.typePaymentName) {
		items.push({ label: 'Tipo de pago', value: this.typePaymentName });
	}
	if (MODULES_WITH_AMORTIZATION.indexOf(code) > -1 && info.typeAmortizationName) {
		items.push({ label: 'Tipo de transacción', value: info.typeAmortizationName });
	}
	const operation = info.operationNumber || info.numberOperation || extra.paymentDocumentNumber;
	if (operation) {
		items.push({ label: 'N° Operación', value: operation });
	}
	const concept = info.concept || extra.concept || '';
	if (extra.beneficiary && extra.beneficiary.trim() !== concept.trim()) {
		items.push({ label: 'Beneficiario', value: extra.beneficiary });
	}
	if (concept) {
		items.push({ label: 'Concepto', value: concept, wide: true });
	}
	if (info.observations && info.observations.trim() !== concept.trim()) {
		items.push({ label: 'Observaciones', value: info.observations, wide: true });
	}
	return items;
}

function getLabelRegister() {
	/* eslint-disable no-nested-ternary */
	const newData = {
		value: null,
		label: '',
	};
	if (this.detailsRegister && this.detailsRegister.data) {
		if (this.detailsRegister.data.customerId) {
			const { customer } = this.detailsRegister.data;
			newData.label = 'Cliente';
			newData.value = customer && customer.rzSocial
				? customer.rzSocial
				: customer && customer.typePerson && customer.typePerson.fullName
					? customer.typePerson.fullName : '';
		} else if (this.detailsRegister.data.supplierId) {
			const { supplier } = this.detailsRegister.data;
			newData.label = 'Proveedor';
			newData.value = supplier && supplier.name
				? supplier.name : '';
		}
	}
	/* eslint-enable no-nested-ternary */
	return newData;
}

export default {
	name: 'ledger-list',
	components: {
		appTooltipButton,
	},
	data,
	computed: {
		detailRows,
		registerData,
		registerDate,
		registerExtra,
		typePaymentName,
	},
	methods: {
		closeDetailDocument,
		getLabelRegister,
		getRegister,
		hasAmount,
		openDetailDocument,
	},
	props: {
		currentPage: {
			type: Number,
			default: 1,
		},
		lastPage: {
			type: Number,
			default: 0,
		},
		rows: {
			type: Array,
			required: true,
		},
		numberSeats: {
			type: Number,
			default: 0,
		},
		itemsQuantity: {
			type: Number,
			default: 0,
		},
		itemsTotalQuantity: {
			type: Number,
			default: 0,
		},
	},
};
</script>

<style lang="scss" scoped>
	$doc-ink: #16222b;
	$doc-ink-2: #5b6b76;
	$doc-muted: #90a0aa;
	$doc-line: #e3e9ec;
	$doc-plane: #f4f7f8;
	$doc-teal: #02979b;
	$doc-teal-dark: #017e82;

	/* ---------------- boton de la celda ---------------- */
	.btn-doc {
		align-items: center;
		background-color: #e8f5f5;
		border: 1px solid #bfe3e4;
		border-radius: 999px;
		color: $doc-teal-dark;
		cursor: pointer;
		display: inline-flex;
		font-family: inherit;
		font-size: 12px;
		font-weight: 700;
		gap: 6px;
		height: 26px;
		padding: 0 12px 0 8px;
		white-space: nowrap;

		.v-icon {
			color: $doc-teal-dark !important;
		}

		&:hover {
			background-color: #d8eeef;
		}
	}

	.btn-doc--empty {
		background-color: transparent;
		border-color: transparent;
		color: $doc-muted;
		cursor: default;
	}

	/* ---------------- modal ---------------- */
	.doc-card {
		border-radius: 14px !important;
		overflow: hidden;
	}

	.doc-card__head {
		align-items: center;
		background-color: $doc-teal;
		color: #ffffff;
		display: flex;
		justify-content: space-between;
		padding: 12px 16px;
	}

	.doc-card__head-left {
		align-items: center;
		display: flex;
	}

	.doc-card__title {
		font-size: 14px;
		font-weight: 700;
		margin-left: 10px;
	}

	.doc-card__close {
		align-items: center;
		background-color: rgba(255, 255, 255, 0.18);
		border: none;
		border-radius: 8px;
		cursor: pointer;
		display: flex;
		height: 28px;
		justify-content: center;
		width: 28px;

		&:hover {
			background-color: rgba(255, 255, 255, 0.3);
		}
	}

	.doc-label {
		color: $doc-ink-2;
		display: block;
		font-size: 9.5px;
		font-weight: 700;
		letter-spacing: 0.9px;
		text-transform: uppercase;
	}

	/* resumen */
	.doc-hero {
		align-items: center;
		background-color: $doc-plane;
		border-bottom: 1px solid $doc-line;
		display: flex;
		justify-content: space-between;
		padding: 14px 18px;
	}

	.doc-hero__doc {
		min-width: 0;
	}

	.doc-hero__number {
		display: block;
		font-size: 18px;
		font-weight: 700;
		margin-top: 2px;
	}

	.doc-hero__chips {
		display: flex;
		margin-top: 6px;
	}

	.doc-chip {
		background-color: #ffffff;
		border: 1px solid $doc-line;
		border-radius: 999px;
		color: $doc-ink-2;
		font-size: 10.5px;
		font-weight: 700;
		margin-right: 6px;
		padding: 2px 10px;
	}

	.doc-chip--module {
		background-color: $doc-teal;
		border-color: $doc-teal;
		color: #ffffff;
	}

	.doc-hero__amount {
		text-align: right;
		white-space: nowrap;
	}

	.doc-hero__value {
		display: block;
		font-size: 24px;
		font-weight: 700;
	}

	/* datos */
	.doc-grid {
		display: grid;
		grid-template-columns: repeat(2, minmax(0, 1fr));
	}

	.doc-item {
		border-bottom: 1px solid $doc-line;
		border-right: 1px solid $doc-line;
		min-width: 0;
		padding: 11px 18px;

		&:nth-child(even) {
			border-right: none;
		}
	}

	.doc-item--wide {
		border-right: none;
		grid-column: 1 / -1;
	}

	.doc-item__value {
		color: $doc-ink;
		display: block;
		font-size: 13px;
		font-weight: 600;
		margin-top: 3px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.doc-item__value--free {
		white-space: normal;
	}

	.doc-card__foot {
		display: flex;
		justify-content: flex-end;
		padding: 12px 18px;
	}

	.doc-btn {
		background-color: $doc-teal;
		border: none;
		border-radius: 8px;
		color: #ffffff;
		cursor: pointer;
		font-family: inherit;
		font-size: 12.5px;
		font-weight: 700;
		height: 34px;
		padding: 0 20px;

		&:hover {
			background-color: $doc-teal-dark;
		}
	}
	.amount-empty {
		color: $doc-muted;
		font-weight: 600;
	}
</style>


// WEBPACK FOOTER //
// src/components/ledger/ledger-list.vue